import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-additonal-landing-page',
  templateUrl: './additonal-landing-page.component.html',
  styleUrls: ['./additonal-landing-page.component.css'],
  encapsulation:ViewEncapsulation.ShadowDom,standalone:false
})
export class AdditonalLandingPageComponent {

}
